<template>
  <li
    v-if="menuItemIsAvailable()"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
    @click="onClick"
  >
    <b-link
      v-bind="linkProps"
      class="dropdown-item w-100"
    >
      <feather-icon
        :icon="item.icon || 'CircleIcon'"
        size="24"
      />
      <span class="menu-title">{{ $t(item.title) }}</span>
    </b-link>
  </li>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import useHorizontalNavMenuLink
  from '@/core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-link/useHorizontalNavMenuLink'
import mixinHorizontalNavMenuLink
  from '@/core/layouts/layout-horizontal/components/horizontal-nav-menu/components/horizontal-nav-menu-link/mixinHorizontalNavMenuLink'
import { getUserData } from '@/auth/utils'
import { entityImportExport } from '@/libs/acl/entities'
import appConstants from '@/constants/constants'

export default {
  components: {
    BLink,
  },
  mixins: [mixinHorizontalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useHorizontalNavMenuLink(props.item)

    const isArr = o => Array.isArray(o)

    return {
      isActive,
      linkProps,
      updateIsActive,
      isArr,
    }
  },
  methods: {
    menuItemIsAvailable() {
      const user = getUserData()
      if (this.item.resource === 'pricingtypevalue') {
        return user && ['sys_admin', 'root', 'support'].includes(user.role_type)
      }
      if (this.item.resource === 'integratorbranch') {
        return user && ['root'].includes(user.role_type)
      }
      if (
        this.item.resource === entityImportExport && user
        && [appConstants.role.type.SYS_ADMIN, appConstants.role.type.SUPPORT].includes(user.role_type)
      ) {
        return true
      }
      if (this.item.resource === 'thirdpartyorganization') {
        return user && ['root'].includes(user.role_type)
      }
      if (!this.menuItemIsAvailableByIntegratorModuleSettings()) {
        return false
      }
      return this.isArr(this.item.resource)
        ? this.item.resource.some(r => this.$can(this.item.action, r))
        : this.$can(this.item.action, this.item.resource)
    },
    onClick() {
      if (this.item.resource === 'schedulerpatient') {
        this.$store.commit('schedule/CLEAR_SELECTED_DOCTORS')
        this.$store.commit('schedule/CLEAR_SELECTED_DOCTOR')
        this.$store.commit('schedule/CLEAR_SELECTED_EVENTS')
        this.$store.commit('schedule/CLEAR_CALENDAR_OPTIONS')
        this.$store.commit('employee/SET_DOCTORS', [])
        this.$store.commit('schedule/CLEAR_ACTIVE_TAB')
        this.$store.commit('schedule/CLEAR_CALENDAR_VIEW')
      }
    },
    menuItemIsAvailableByIntegratorModuleSettings() {
      const user = getUserData()
      if (user) {
        if (user.isRoot) {
          return true
        }
        return user.system_modules.includes(this.item.route)
      }
      return true
    }
  }
}
</script>
